import numeral from 'numeral';
import { Component } from 'react';
import Loading from '../../../components/Loading';
import { getPlans, getPlansCoupon } from './query';

class PromoCode extends Component {
    constructor(props) {
        super(props);
        this.updateState = this.updateState.bind(this);
        this.sendPromoCode = this.sendPromoCode.bind(this);
        this.changeLoading = this.changeLoading.bind(this);
        console.log('props', props);
        try {
            if (props.price) this.price = JSON.parse(props.price);
        } catch (e) {
            this.price = {};
        }

        try {
            if (props.product) this.product = JSON.parse(props.product);
        } catch (e) {
            this.product = {};
        }

        try {
            if (props.price) this.price = JSON.parse(props.price);
        } catch (e) {
            this.price = {};
        }

        try {
            if (props.product) this.product = JSON.parse(props.product);
        } catch (e) {
            this.product = {};
        }

        this.state = {
            loading: false,
            price: this.price ?? {},
            promotion: {},
            product: this.product ?? {},
            discount_price: props.discount_price,
            product_id: props.product_id,
            successMessage: '',
            message: props.message,
            ai_credits: props.ai_credits,
            data: {
                promotion_code: '',
            },
            show_plans: [],
        };
    }

    async componentDidMount() {
        try {
            const response = await getPlans({ product_id: this.state.product_id });
            const data = await response.json();
            this.setState({
                show_plans: data?.related_plans,
                promotion: data?.promotion,
                defaultData: data,
            });
        } catch (err) {
            console.log(err);
        }
    }

    updateData(key, e) {
        const data = { ...this.state.data };
        data[key] = e.target.val || e.target.value;
        this.setState({ data });
    }

    updateState(data) {
        const {
            discount_price,
            promotion,
            message,
            related_plans,
            successMessage = '',
            status,
        } = data;

        if (status === 200) {
            const promotionId = promotion?.active ? promotion?.id : '';
            this.props.setPromotionCode(promotionId);

            this.setState({
                discount_price,
                promotion,
                message,
                successMessage,
                show_plans: related_plans ?? this.state.show_plans,
            });
        } else {
            this.props.setPromotionCode(null);
            this.setState({
                discount_price: null,
                promotion: {},
                message,
                successMessage: '',
                show_plans: this.state.defaultData?.related_plans ?? this.state.show_plans,
            });
        }
    }

    changeLoading(bool) {
        this.setState({
            loading: bool,
        });
    }

    async sendPromoCode(e) {
        try {
            e.preventDefault();
            const {
                data: { promotion_code },
            } = this.state;

            this.changeLoading(true);
            const res = await getPlansCoupon({ product_id: this.state.product_id, promotion_code });
            const data = await res.json();

            if (data.discount_price !== null) {
                data.successMessage = data.promotion?.percent_off
                    ? `Promo code applied, ${data.promotion.percent_off}% discount added to your subscription.`
                    : `Promo code applied, ${numeral(data.amount_off).format(
                          '$0.00',
                      )} discount added to your subscription`;
            }
            this.updateState(data);
            this.changeLoading(false);
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const {
            discount_price,
            price,
            product,
            promotion,
            message,
            data: { promotion_code },
            loading,
            show_plans,
            successMessage,
        } = this.state;

        return (
            <div className="col-lg-6 col-sm-6 col-xs-12">
                <div className="form-info">
                    <div className="registration-container-left">
                        <div className="registration-title">
                            You&apos;re registering for the GDDash
                        </div>
                        <div className="registration-product-name">{product?.name}</div>
                        <div className="registration-product-information">
                            <div className="registration-product-information-container">
                                <div className="registration-product-information-box">
                                    <img src="/static/img/free-trial.svg" />
                                    14-Day FREE Trial
                                </div>
                                {price?.recurring && (
                                    <div className="registration-product-information-container-info">
                                        Then billed at{' '}
                                        {promotion?.active && promotion?.coupon ? (
                                            <>
                                                <span style={{ textDecoration: 'line-through' }}>
                                                    {' '}
                                                    {numeral(price.amount).format('$0.00')}
                                                </span>
                                                <strong style={{ display: 'inline-block' }}>
                                                    {' '}
                                                    {numeral(discount_price).format('$0.00')}
                                                </strong>
                                            </>
                                        ) : (
                                            <strong>{numeral(price.amount).format('$0.00')}</strong>
                                        )}
                                        /{price?.recurring?.interval_count ?? ''}{' '}
                                        {`${price?.recurring?.interval ?? '-'}${
                                            price?.recurring?.interval_count > 1 ? 's' : ''
                                        }`}
                                        <br />
                                        Cancel anytime
                                    </div>
                                )}
                            </div>
                            <div className="registration-product-information">
                                <div className="registration-product-information-container">
                                    <div className="registration-product-information-box">
                                        <img src="/static/img/domains_icon.svg" />
                                        {this.props.ai_credits
                                            ? `${this.props.ai_credits} AI Credits`
                                            : `${this.props.domains_count} Domains`}
                                    </div>
                                    <div className="registration-product-information-container-info">
                                        {this.props.ai_credits ? (
                                            'Number of AI Credits'
                                        ) : (
                                            <>
                                                Only one domain will be active
                                                <br />
                                                during free trial
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className={`registration-coupon-code-container ${
                                message ? 'with-error' : ''
                            } ${successMessage ? 'with-success' : ''}`}
                        >
                            <form
                                className="registration-coupon-code"
                                onSubmit={this.sendPromoCode}
                            >
                                <div className="text-field">
                                    <div className="success-check">
                                        <i className="icon-check-icon" />
                                    </div>
                                    <input type="hidden" name="product_id" value={price?.id} />
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="promotion_code"
                                        onChange={this.updateData.bind(this, 'promotion_code')}
                                        value={promotion_code}
                                        placeholder="Discount Code"
                                        disabled={loading}
                                    />
                                    <button
                                        type="submit"
                                        className="submit-btn"
                                        id="coupon-code-submit"
                                    >
                                        Apply
                                    </button>
                                </div>
                                {loading && <Loading padding={'10px 0'} />}
                            </form>

                            {message && !loading && (
                                <div className="error-message">
                                    <i className="icon-fi_info mr-5" />
                                    {message}
                                </div>
                            )}
                            {successMessage && !loading && (
                                <div className="success-message">
                                    <i className="icon-check-icon mr-5" />
                                    {successMessage}
                                </div>
                            )}
                        </div>

                        {!!show_plans?.length && (
                            <div className="registration-special-offer">
                                <div className="registration-special-offer-title">
                                    <img src="/static/img/special_offer.svg" />
                                    <div className="registration-special-offer-title-text">
                                        <div>We have a special offer for you!</div>
                                        <div>
                                            Upgrade plan to <strong>save even more</strong>
                                        </div>
                                    </div>
                                </div>
                                {show_plans.map((item) => (
                                    <div
                                        key={item.plan_id}
                                        className="registration-special-offer-box"
                                    >
                                        <div className="registration-special-offer-box-text">
                                            <div className="first-child">
                                                {item.plan_name} Billing{' '}
                                                <span>{item.discount_off_name}</span>
                                            </div>
                                            <div className="second-child">
                                                {item.discount_amount_label ? (
                                                    <>
                                                        <div
                                                            style={{
                                                                textDecoration: 'line-through',
                                                            }}
                                                        >
                                                            {' '}
                                                            {numeral(item.plan_amount_label).format(
                                                                '$0.00',
                                                            )}
                                                        </div>
                                                        {numeral(item.discount_amount_label).format(
                                                            '$0.00',
                                                        )}
                                                    </>
                                                ) : (
                                                    numeral(item.plan_amount_label).format('$0.00')
                                                )}{' '}
                                                ({item.period})
                                            </div>
                                        </div>
                                        <a
                                            href={`/customers/registration/?product_id=${item.plan_id}`}
                                        >
                                            Upgrade
                                        </a>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default PromoCode;
